export default "__VITE_ASSET__CPKt1E2M__"